"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var tslib_1 = require("tslib");
var date = tslib_1.__importStar(require("./date"));
var legacy = tslib_1.__importStar(require("./legacy"));
var factory_1 = require("./factory");
exports.create = factory_1.create([date, legacy]);
//# sourceMappingURL=expression.js.map